import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITable } from "src/models/Products/Table.models";

interface TableState {
  tables: ITable[];
  tableToEdit: ITable | null;
}

const initialState: TableState = {
  tables: [],
  tableToEdit: null,
};

const tableSlice = createSlice({
  name: "Table",
  initialState,
  reducers: {
    setTableList: (state, action: PayloadAction<ITable[]>) => {
      state.tables = action.payload;
    },
    concatListTable: (state, action: PayloadAction<ITable[]>) => {
      state.tables = [...state.tables.concat(action.payload)];
    },
    setTableToEdit: (state, action: PayloadAction<ITable | null>) => {
      state.tableToEdit = action.payload;
    },
    addTable: (state, action: PayloadAction<ITable>) => {
      state.tables.push(action.payload);
    },
    addTables: (state, action: PayloadAction<ITable[]>) => {
      state.tables.push(...action.payload);
    },
    updateTable: (state, action: PayloadAction<ITable>) => {
      const index = state.tables.findIndex(
        item => item.ordTableId === action.payload.ordTableId
      );
      if (index !== -1) state.tables[index] = action.payload;
    },
    deleteTable: (state, action: PayloadAction<string>) => {
      state.tables = state.tables.filter(
        item => item.ordTableId !== action.payload
      );
    },
  },
});

export const {
  setTableList,
  concatListTable,
  setTableToEdit,
  addTable,
  addTables,
  updateTable,
  deleteTable,
} = tableSlice.actions;

export default tableSlice.reducer;
